import { useState, useEffect } from 'react';
import { getUserInfo, UserInfo } from '../services/auth/authApi';

export const useUserInfoSimple = () => {
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const loadUserInfo = async () => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      setUserInfo(null);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      console.log('Simple hook: Loading user info...');
      const info = await getUserInfo();
      console.log('Simple hook: User info loaded:', info);
      setUserInfo(info);
    } catch (err) {
      console.error('Simple hook: Failed to load user info:', err);
      setError(err instanceof Error ? err.message : '사용자 정보 로드 실패');
      
      if (err instanceof Error && err.message.includes('401')) {
        localStorage.removeItem('access_token');
        setUserInfo(null);
      }
    } finally {
      setLoading(false);
    }
  };

  const refresh = async () => {
    await loadUserInfo();
  };

  // 초기 로드
  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      loadUserInfo();
    }
  }, []);

  return {
    userInfo,
    loading,
    error,
    refresh,
  };
};
